import type { FieldValues } from "react-hook-form";
import { FormComponent } from "../FormComponent";
import { FormInput, type FormInputProps, type InputFilterProps } from "../fields/FormInput";
import type { FormComponentProps } from "../types";

// Omit the union discriminants and re-intersect them — Omit on a union collapses the mutual exclusivity of onlyCharacters/onlyNumbers.
export type FormInputComponentProps<TFieldValues extends FieldValues> =
	FormComponentProps<TFieldValues> &
		Omit<FormInputProps<TFieldValues>, "control" | "onlyCharacters" | "onlyNumbers"> &
		InputFilterProps;

export const FormInputComponent = <TFieldValues extends FieldValues>(
	props: FormInputComponentProps<TFieldValues>,
) => {
	const { formMethods, ...restProps } = props;
	const { control } = formMethods;
	return (
		<FormComponent {...props}>
			<FormInput control={control} {...restProps} />
		</FormComponent>
	);
};
